<!-- @format -->

<button
	[class]="{
		'hmf-position-relative': true,
		disabled: disabled(),
		selected: selected(),
		'plp-image-swatch-selected': imageSwatchHoverDimension()
	}"
	[attr.aria-label]="swatchAriaLabel"
	[title]="color()"
	[ngStyle]="{ 'border-radius': radius() }"
	(click)="attributeValueClicked($event.currentTarget)">
	<img
		[attr.loading]="isLazy() ? 'lazy' : 'eager'"
		[src]="imageSrc()"
		[class]="{ selected: selected() }"
		[ngStyle]="{
			height: height(),
			width: width(),
			'border-radius': radius()
		}"
		[alt]="color()"
		(error)="emitImageError($event)" />
</button>
